module.exports = "export default __webpack_public_path__ + &quot;37aa90aeab71afecc07b41b9ee3cac5d.svg&quot;;"